import type { IBrandConfig } from './types';

const DISCOVER_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/privacy-policy',
  },
  termsOfService: {
    kind: 'cms',
    path: 'policy/tou/identity-theft-protection.md',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'identityguard_watson',
  adaChat: true,
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  carouselBanners: true,
  security: true,
  finishSetup: false,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default DISCOVER_BRAND_CONFIG;
